import { render, staticRenderFns } from "./GButton.vue?vue&type=template&id=8dfe708a&"
import script from "./GButton.vue?vue&type=script&lang=js&"
export * from "./GButton.vue?vue&type=script&lang=js&"
import style0 from "./GButton.vue?vue&type=style&index=0&id=8dfe708a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports